import { INSTANCELIST, INSTANCE } from './API.js'

export const getCalendarEvents = ({ queryKey }) =>
  new Promise((resolve, reject) => {
    const { sort, range, filter } = queryKey[1]

    INSTANCELIST({
      method: 'get',
      url: '/calendar-events',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      params: {
        sort: JSON.stringify(sort),
        range: JSON.stringify(range),
        filter: JSON.stringify(filter),
      },
    })
      .then(resolve)
      .catch(reject)
  })

export const createCalendarEvent = (data) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'post',
      url: '/calendar-events',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data,
    })
      .then(resolve)
      .catch(reject)
  })

export const getCalendarEventDetails = ({ queryKey }) =>
  new Promise((resolve, reject) => {
    const { id } = queryKey[1]

    INSTANCE({
      method: 'get',
      url: `/calendar-events/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(resolve)
      .catch(reject)
  })

export const updateCalendarEvent = (id, data) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'put',
      url: `/calendar-events/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data,
    })
      .then(resolve)
      .catch(reject)
  })

export const deleteCalendarEvent = (id) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'delete',
      url: `/calendar-events/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(resolve)
      .catch(reject)
  })
